import React, { Component } from 'react';
import Button from "../elements/Button";

class ServiceBlockMobile extends Component {

    render() {
        const List = (services) => {
            return services.map((service, key) => {
                return (
                    <li key={key}>{service}</li>
                );
            });
        };

        return (
            <div>
                <div className={'tab ' + (this.props.active ? 'active' : '')} onClick={this.props.handleClick}>
                    <h3>{this.props.title}</h3>
                </div>
                <div className={'tab-content ' + (this.props.active ? 'active' : '')}>
                    <div className="tab-content-inner">
                        <ul>
                            {List(this.props.items)}
                        </ul>
                        <Button action={this.props.url} image="/images/btn-learn-more-white.svg" />
                    </div>
                    <div className="bottom-wave-darkgreen" />
                </div>
            </div>
        );
    }

}

export default ServiceBlockMobile;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/ServiceBlockMobile.js